import { Outlet } from "react-router-dom";

function AgentsMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default AgentsMain;